import { render, staticRenderFns } from "./BackgroundSection.vue?vue&type=template&id=c12f7c88&scoped=true&"
import script from "./BackgroundSection.vue?vue&type=script&lang=ts&"
export * from "./BackgroundSection.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundSection.vue?vue&type=style&index=0&id=c12f7c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12f7c88",
  null
  
)

export default component.exports